<template>
    <a :href="this.actionLink" target="_blank">
      <img class="img-special-banners" :src="this.srcImg" alt="Special Banner"/>
    </a>
</template>

<script>
export default {
    name: "dv5-right-special-banners",
    props: ["srcImg", "actionLink"],
    data() {
        return {}
    },
    created() {},
    methods: {}
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.img-special-banners {
    width: 350px;
    margin-bottom: 10px;
    border-radius: 4px;
}

@media screen and (max-width: 700px) {
    .img-special-banners {
        width: 100%;
        padding: 0 .6em 0 .5em;
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/banners/RightSpecialBanners.vue